import React from "react"
import useBreakpoint from "../hooks/useBreakpoint"
import { useStaticQuery, graphql } from "gatsby"

interface Laureate {
  laureateName: string
  laureateCountry: string
  laureateCitation: string
  laureateArticleLink: string
  laureateImage: {
    asset: {
      url: string
    }
  }
}

interface SanityLaureates {
  sanityLaureates: {
    laureateList: Laureate[]
  }
}

const LargeLaureateTeaser = ({ laureate }: { laureate: Laureate }) => {
  const {
    laureateName,
    laureateCountry,
    laureateCitation,
    laureateArticleLink,
    laureateImage,
  } = laureate

  return (
    <div className="laureate">
      <a className="laureate__name" href={laureateArticleLink}>
        {laureateName}
        <i>{laureateCountry}</i>
      </a>

      <a className="laureate__image" href={laureateArticleLink}>
        <img src={laureateImage.asset.url} />
      </a>

      <blockquote>{laureateCitation}</blockquote>
    </div>
  )
}

const SmallLaureateTeaser = ({ laureate }: { laureate: Laureate }) => {
  const {
    laureateName,
    laureateCountry,
    laureateCitation,
    laureateArticleLink,
    laureateImage,
  } = laureate

  return (
    <a href={laureateArticleLink} className="laureate">
      <img className="laureate__image" src={laureateImage.asset.url} />

      <div className="laureate__text">
        <div className="laureate__name">
          {laureateName}
          <i>{laureateCountry}</i>
        </div>

        <blockquote>{laureateCitation}</blockquote>
      </div>
    </a>
  )
}

export default () => {
  const { sanityLaureates }: SanityLaureates = useStaticQuery(graphql`
    query {
      sanityLaureates {
        laureateList {
          laureateName
          laureateCountry
          laureateCitation
          laureateArticleLink
          laureateImage {
            asset {
              url
            }
          }
        }
      }
    }
  `)

  const { laureateList } = sanityLaureates

  const { isDesktop } = useBreakpoint()

  return (
    <section className="laureates">
      <h2>The 2020 Laureates</h2>

      {laureateList.map(laureate => {
        return (
          <React.Fragment key={laureate.laureateName}>
            {isDesktop ? (
              <LargeLaureateTeaser laureate={laureate} />
            ) : (
              <SmallLaureateTeaser laureate={laureate} />
            )}
          </React.Fragment>
        )
      })}
    </section>
  )
}
